
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/impressum",
      function () {
        return require("private-next-pages/legal/impressum.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/impressum"])
      });
    }
  